import React from 'react';
import { Starfield } from './components/Starfield';
import { Navbar } from './components/Navbar';
import { Hero } from './components/sections/Hero';
import { Pillars } from './components/sections/Pillars';
import { Events } from './components/sections/Events';
import { Records } from './components/sections/Records';
import { About } from './components/sections/About';
import { Stage } from './components/sections/Stage';
import { Instagram } from './components/sections/Instagram';
import { AstroSwag } from './components/sections/AstroSwag';
import { Contact } from './components/sections/Contact';
import { Footer } from './components/sections/Footer';
import { Downloads } from './components/sections/Downloads';

// NOTE: the Artists ("Artists in orbit") section is ARCHIVED, not deleted —
// components/sections/Artists.tsx stays in the repo; re-import + mount it here
// (and restore its NAV_LINKS entry in data/site.ts) to bring it back.
// The standalone Social section is MERGED into Instagram (chip bar at its top);
// components/sections/Social.tsx stays in the repo if the tile layout is ever wanted back.
// The Photo Gallery section is ARCHIVED (Ryan, Aug 29 — placeholder images were
// showing); components/sections/Gallery.tsx stays in the repo — re-import + mount
// between Instagram and AstroSwag to bring it back once real photos exist.
// The NEWSLETTER section is ARCHIVED (Ryan, Aug 29 — replaced by Contact);
// components/sections/Newsletter.tsx stays in the repo — re-import + mount to restore.
// The Downloads crate is a HIDDEN section: a hash-driven overlay (#downloads),
// opened from the FREE DOWNLOADS button in Records — not part of the snap flow.

export function App() {
  return (
    /* NOTE: no overflow-x-hidden here — it would make this div a scroll container and
       detach the sections from the page's scroll-snap. Horizontal clipping is done with
       overflow-x: clip on html in snap.css, which does NOT create a scroll container. */
    <div className="app-shell relative min-h-screen w-full bg-void" data-id="element-0" data-mp="3688rpx40wyp">
      <Starfield data-id="element-1" data-mp="38b5essrpoce" />
      <Navbar data-id="element-2" data-mp="3ud1hdeu8fyd9" />
      <main className="relative z-10" data-id="element-3" data-mp="3udaxmaph6r5r">
        {/* Hero + Pillars form one exact-viewport snap unit (see polish.css .home-unit) */}
        <div className="home-unit" data-id="element-4" data-mp="d45rxz0443kg">
          <Hero data-id="element-5" data-mp="d2bfl92wpjrz" />
          <Pillars data-id="element-6" data-mp="85ully910b6z" />
        </div>
        <Events data-id="element-7" data-mp="86w76wno4g2y" />
        <Stage data-id="element-8" data-mp="86cmx9ajpflr" />
        <Records data-id="element-9" data-mp="83qgxe3az85n" />
        <Instagram data-id="element-10" data-mp="3gl4srkrrw6lm" />
        <AstroSwag data-id="element-11" data-mp="3gklag2y7ng72" />
        <About data-id="element-12" data-mp="3gm665vw9h56i" />
        <Contact data-id="element-13" data-mp="3glo067jsrcle" />
      </main>
      <Footer data-id="element-14" data-mp="3bmbf9schkflg" />
      <Downloads data-id="element-15" data-mp="3bmtjbb5e3y3x" />
    </div>
  );
}